import { ModelBase } from 'store/model-base';

export class CmsTradeInDevice extends ModelBase {
    public static storeName: string = 'cmsTradeInDevice';

    public details: CmsTradeInDeviceDetail[];
}
